<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    //
  }),
  watch: {
    $route(to) {
      document.title = to.meta.displayName || "Lockton Website";
    }
  }
};
</script>
<style lang="sass"></style>
